export default defineNuxtRouteMiddleware(to => {
    if (process.client) {
        return;
    }
    if (['/khorramabad', '/astara', '/neyshabur'].includes(to.path)) {
        showError({ statusCode: 410, message: 'Page Removed' });
    }
});
